
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Mail } from 'lucide-react';

const SignupConfirmationPage: React.FC = () => {
  const location = useLocation();
  const { email, name } = location.state || { email: '', name: '' };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <CheckCircle className="mx-auto h-16 w-16 text-green-500" />
          <h1 className="mt-4 text-3xl font-bold text-gray-900">Account Created!</h1>
          <p className="mt-2 text-gray-600">Your referral account has been created successfully.</p>
        </div>
        
        <Card className="border-0 shadow-xl bg-white/90 backdrop-blur-sm">
          <CardHeader className="pb-2">
            <CardTitle className="text-xl font-bold">Check Your Email</CardTitle>
            <CardDescription>We've sent you an activation link</CardDescription>
          </CardHeader>
          <CardContent className="pt-4">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-6">
              <div className="flex items-start">
                <Mail className="h-6 w-6 text-blue-500 mr-3 mt-1" />
                <div>
                  <p className="text-blue-800 font-medium">Activation Email Sent</p>
                  <p className="text-blue-700 text-sm mt-1">
                    We've sent an activation email to <strong>{email || 'your email address'}</strong>. 
                    Please check your inbox and click the activation link to complete your signup.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <p className="text-gray-600 text-sm">
                After activating your account, you'll receive your unique referral code and QR code 
                to start referring friends and earning points.
              </p>
              
              <p className="text-gray-600 text-sm">
                If you don't see the email in your inbox, please check your spam folder.
              </p>
              
              <div className="flex space-x-4 mt-6">
                <Button asChild variant="outline" className="w-full">
                  <Link to="/login">Go to Login</Link>
                </Button>
                <Button asChild className="w-full">
                  <Link to="/">Home Page</Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SignupConfirmationPage;
